module.exports = __webpack_public_path__ + "media/customizations/christensoncommunities/back-c7fac5631eae009b0b1a4eeea7ade878.jpg";